const LOCAL_STORAGE_SCRATCHCARD_RENDER_GLOW_EFFECT = 'scratchcard-render-glow-effect'

const LOCAL_STORAGE_SCRATCHCARD_SCRATCH_DIAMETER = 'scratchcard-scratch-diameter'

export const useScratchcardScratchSettings = () => {
  const scratchDiameter = useLocalStorage(LOCAL_STORAGE_SCRATCHCARD_SCRATCH_DIAMETER, 50)
  const renderGlowEffect = useLocalStorage(LOCAL_STORAGE_SCRATCHCARD_RENDER_GLOW_EFFECT, true)

  return {
    renderGlowEffect,
    scratchDiameter,
  }
}
